import { useTheme } from '@emotion/react';

const MachineLearningPageStyle = () => {
  const theme = useTheme();

  return {
    // Main container styles
    container: {
      padding: '24px',
      borderRadius: '12px',
      marginBottom: '24px',
    },

    // Header styles
    title: {
      fontWeight: '600',
      fontSize: '28px',
      marginBottom: '24px',
      color: '#1a1a1a',
    },

    // Example section card
    exampleCard: {
      padding: '24px',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
      backgroundColor: '#f8f9fa',
      marginBottom: '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },

    exampleTitle: {
      fontWeight: '600',
      fontSize: '16px',
      marginBottom: '12px',
      color: '#1a1a1a',
    },

    exampleText: {
      fontSize: '14px',
      lineHeight: '1.6',
      color: '#4a5568',
    },

    // Input section card
    inputCard: {
      padding: '24px',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
      backgroundColor: 'white',
      marginBottom: '24px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.10)',
      },
    },

    textField: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
        '& fieldset': {
          borderColor: '#e5e5e5',
        },
        '&:hover fieldset': {
          borderColor: '#0ea5e9',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#0ea5e9',
        },
      },
    },

    // Entity card styles with confidence-based coloring
    highConfidenceCard: {
      background: 'white',
      color: '#1a1a1a',
      marginBottom: '16px',
      borderRadius: '12px',
      border: '1px solid #dcfce7',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        borderColor: '#bbf7d0',
      },
      '&:before': {
        display: 'none'
      },
    },

    mediumConfidenceCard: {
      background: 'white',
      color: '#1a1a1a',
      marginBottom: '16px',
      borderRadius: '12px',
      border: '1px solid #fde68a',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        borderColor: '#fcd34d',
      },
      '&:before': {
        display: 'none'
      },
    },

    lowConfidenceCard: {
      background: 'white',
      color: '#1a1a1a',
      marginBottom: '16px',
      borderRadius: '12px',
      border: '1px solid #fee2e2',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        borderColor: '#fecaca',
      },
      '&:before': {
        display: 'none'
      },
    },

    // Entity card header
    entityCardHeader: {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      padding: '16px',
    },

    entityTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1a1a1a',
    },

    // Results section
    resultsTitle: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '24px',
    },

    // Empty state
    emptyState: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '200px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
    },

    // Back button
    arrow_button: {
      marginTop: '-16px',
      marginBottom: '16px',
      transition: 'all 0.2s ease',
      '&:hover': {
        transform: 'translateX(-4px)',
      },
    },

    arrow_icon: {
      fontSize: '32px',
      color: theme.palette.primary.main,
    },

    // Concept list item
    conceptItem: {
      padding: '12px 16px',
      borderRadius: '8px',
      marginBottom: '8px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #e5e5e5',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'white',
        borderColor: '#0ea5e9',
      },
    },

    conceptDescription: {
      fontWeight: '500',
      color: '#1a1a1a',
      marginBottom: '4px',
    },
  };
};

export default MachineLearningPageStyle;
